// export const BASE_URL = "http://localhost:1111";
export const BASE_URL = "https://projecthunt-api.herokuapp.com";

// user constant
export const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAIL = "USER_LOGIN_FAIL";
export const USER_LOGOUT = "USER_LOGOUT";

export const USER_REGISTER_REQUEST = "USER_REGISTER_REQUEST";
export const USER_REGISTER_SUCCESS = "USER_REGISTER_SUCCESS";
export const USER_REGISTER_FAIL = "USER_REGISTER_FAIL";
export const USER_REGISTER_RESET = "USER_REGISTER_RESET";

// project constant
export const ADD_PROJECT_REQUEST = "ADD_PROJECT_REQUEST";
export const ADD_PROJECT_SUCCESS = "ADD_PROJECT_SUCCESS";
export const ADD_PROJECT_FAIL = "ADD_PROJECT_FAIL";
export const ADD_PROJECT_RESET = "ADD_PROJECT_RESET";

export const SINGLE_PROJECT_REQUEST = "SINGLE_PROJECT_REQUEST";
export const SINGLE_PROJECT_SUCCESS = "SINGLE_PROJECT_SUCCESS";
export const SINGLE_PROJECT_FAIL = "SINGLE_PROJECT_FAIL";
export const SINGLE_PROJECT_RESET = "SINGLE_PROJECT_RESET";

export const ALL_PROJECT_REQUEST = "ALL_PROJECT_REQUEST";
export const ALL_PROJECT_SUCCESS = "ALL_PROJECT_SUCCESS";
export const ALL_PROJECT_FAIL = "ALL_PROJECT_FAIL";
export const ALL_PROJECT_RESET = "ALL_PROJECT_RESET";

export const FEATURED_PROJECT_REQUEST = "FEATURED_PROJECT_REQUEST";
export const FEATURED_PROJECT_SUCCESS = "FEATURED_PROJECT_SUCCESS";
export const FEATURED_PROJECT_FAIL = "FEATURED_PROJECT_FAIL";
export const FEATURED_PROJECT_RESET = "FEATURED_PROJECT_RESET";

// user constant
export const TOPMAKERS_USER_REQUEST = "TOPMAKERS_USER_REQUEST";
export const TOPMAKERS_USER_SUCCESS = "TOPMAKERS_USER_SUCCESS";
export const TOPMAKERS_USER_FAIL = "TOPMAKERS_USER_FAIL";
export const TOPMAKERS_USER_RESET = "TOPMAKERS_USER_RESET";

export const USER_PROFILE_REQUEST = "USER_PROFILE_REQUEST";
export const USER_PROFILE_SUCCESS = "USER_PROFILE_SUCCESS";
export const USER_PROFILE_FAIL = "USER_PROFILE_FAIL";
export const USER_PROFILE_RESET = "USER_PROFILE_RESET";

export const CURRENT_USER_PROFILE_REQUEST = "CURRENT_USER_PROFILE_REQUEST";
export const CURRENT_USER_PROFILE_SUCCESS = "CURRENT_USER_PROFILE_SUCCESS";
export const CURRENT_USER_PROFILE_FAIL = "CURRENT_USER_PROFILE_FAIL";
export const CURRENT_USER_PROFILE_RESET = "CURRENT_USER_PROFILE_RESET";

export const UPDATE_USER_PROFILE_REQUEST = "UPDATE_USER_PROFILE_REQUEST";
export const UPDATE_USER_PROFILE_SUCCESS = "UPDATE_USER_PROFILE_SUCCESS";
export const UPDATE_USER_PROFILE_FAIL = "UPDATE_USER_PROFILE_FAIL";
export const UPDATE_USER_PROFILE_RESET = "UPDATE_USER_PROFILE_RESET";
